const avatars = [
  "https://public.readdy.ai/ai/img_res/cc92e986d2adb64e65542ed7fdfee304.jpg",
  "https://readdy.ai/api/search-image?query=smiling%20middle-aged%20white%20man%20headshot%20portrait%20natural%20light%20minimal%20background%20short%20hair&width=48&height=48&seq=av2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=happy%20young%20Asian%20woman%20headshot%20portrait%20natural%20light%20casual%20smile%20minimal%20background&width=48&height=48&seq=av3&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cheerful%20Black%20man%20close%20up%20portrait%20soft%20natural%20light%20gentle%20smile%20minimal%20background&width=48&height=48&seq=av4&orientation=squarish",
  "https://readdy.ai/api/search-image?query=smiling%20Latina%20mother%20headshot%20portrait%20natural%20light%20warm%20skin%20brown%20hair%20minimal%20background&width=48&height=48&seq=av5&orientation=squarish",
  "https://readdy.ai/api/search-image?query=happy%20white%20woman%20headshot%20portrait%20natural%20light%20blonde%20hair%20casual%20smile%20minimal%20background&width=48&height=48&seq=av6&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cheerful%20young%20South%20Asian%20man%20headshot%20portrait%20natural%20light%20minimal%20background&width=48&height=48&seq=av7&orientation=squarish",
];

export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="min-h-screen flex flex-col bg-olive-100">
      <div className="flex flex-1 min-h-screen flex-col lg:flex-row">
        <div className="flex-1 flex flex-col justify-center px-6 md:px-12 lg:px-16 py-24 pt-28 lg:pt-24 max-w-[600px] mx-auto lg:mx-0">
          <div className="mb-8 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
            <img
              alt="Wellness & Freedom"
              className="h-60 w-auto"
              src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/443df1affaea583ef478b831047f4683.png"
            />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-olive-900 leading-[1.1] mb-6 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
            Create More Freedom
            <br />
            for Your Family —{" "}
            <span className="text-olive-500">Naturally.</span>
          </h1>
          <p className="text-olive-700 text-base leading-relaxed mb-10 max-w-md animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
            Discover how busy families are{" "}
            <strong className="font-semibold">earning extra income</strong> and{" "}
            <strong className="font-semibold">living healthier</strong> with
            simple, eco-friendly solutions.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-12 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
            <a
              href="https://calendly.com/carol-berry305"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-olive-600 hover:bg-olive-700 text-white font-semibold px-7 py-3.5 rounded-full text-sm transition-all hover:scale-105 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="fas fa-calendar-alt text-xs"></i>
              </span>
              Book a Free Call
            </a>
            <button
              onClick={() => handleScroll("#paths")}
              className="whitespace-nowrap inline-flex items-center gap-2 border border-olive-600 text-olive-700 hover:bg-olive-100 font-semibold px-7 py-3.5 rounded-full text-sm transition-all cursor-pointer"
            >
              Explore the Paths
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="fas fa-arrow-right text-xs"></i>
              </span>
            </button>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 animate-fadeInUp" style={{ animationDelay: '0.5s' }}>
            <div className="flex items-center">
              {avatars.map((src, i) => (
                <div
                  key={i}
                  className="w-9 h-9 rounded-full overflow-hidden border-2 border-white -ml-2 first:ml-0"
                >
                  <img
                    alt={`Family member ${i + 1}`}
                    className="w-full h-full object-cover object-top"
                    src={src}
                  />
                </div>
              ))}
            </div>
            <div>
              <p className="text-sm font-bold text-olive-800">500+ families</p>
              <p className="text-xs text-olive-500">already on the journey</p>
            </div>
            <div className="flex items-center gap-1.5 text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="w-3 h-3 flex items-center justify-center">
                  <i className="fas fa-star text-xs"></i>
                </span>
              ))}
              <span className="text-xs text-olive-600 ml-1 font-medium">
                5.0 rated by families
              </span>
            </div>
          </div>
        </div>

        <div className="hidden lg:block flex-1 relative min-h-screen">
          <img
            alt="Happy family living naturally"
            className="w-full h-full object-cover object-top"
            src="https://readdy.ai/api/search-image?query=happy%20mother%20with%20two%20young%20daughters%20in%20a%20bright%20modern%20white%20kitchen%20with%20natural%20light%2C%20plants%20on%20shelves%2C%20wooden%20accents%2C%20mother%20bending%20down%20holding%20children%20hands%2C%20warm%20cozy%20family%20moment%2C%20lifestyle%20photography%2C%20clean%20minimal%20interior%2C%20natural%20sunlight%20through%20window&width=700&height=900&seq=hero-family-kitchen&orientation=portrait"
          />
          <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-olive-100 to-transparent pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
}